import React from 'react';
import { FeeTypeSelector } from './FeeTypeSelector';
import { NumberInputRow } from '@/components/form/NumberInputRow';
import { Label } from '@/components/ui/label';

interface FeeAmountFieldsetProps {
  type?: 'percentage' | 'fixed';
  onTypeChange: (type: 'percentage' | 'fixed') => void;
  percentageInputProps?: Record<string, unknown>;
  percentageErrorElement?: React.ReactNode;
  fixedInputProps?: Record<string, unknown>;
  fixedErrorElement?: React.ReactNode;
  idPrefix: string;
  percentageLabel?: React.ReactNode;
  fixedLabel?: React.ReactNode;
}

export const FeeAmountFieldset: React.FC<FeeAmountFieldsetProps> = ({
  type = 'percentage',
  onTypeChange,
  percentageInputProps,
  percentageErrorElement,
  fixedInputProps,
  fixedErrorElement,
  idPrefix,
  percentageLabel = 'Percentage',
  fixedLabel = 'Amount'
}) => {
  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <Label className="text-base text-foreground">Fee Type</Label>
        <p className="text-xs text-muted-foreground">
          Choose whether to apply a percentage or an additional dollar amount
        </p>
      </div>
      <FeeTypeSelector
        value={type}
        onChange={onTypeChange}
        idPrefix={idPrefix}
      />

      <NumberInputRow
        id={`${idPrefix}Amount`}
        label={type === 'fixed' ? fixedLabel : percentageLabel}
        description={
          type === 'fixed' 
            ? "Enter the fixed dollar amount to charge"
            : "Enter the percentage of the invoice total to charge"
        }
        unit={type === 'fixed' ? '$' : '%'}
        unitPosition={type === 'fixed' ? 'left' : 'right'}
        placeholder={type === 'fixed' ? 'e.g. 25' : 'e.g. 2.5'}
        inputProps={type === 'fixed' ? (fixedInputProps || {}) : (percentageInputProps || {})}
        errorElement={type === 'fixed' ? fixedErrorElement : percentageErrorElement}
      />
    </div>
  );
};
